import { render } from "./ConfFormulario.vue?vue&type=template&id=2aaa8672"
import script from "./ConfFormulario.vue?vue&type=script&lang=js"
export * from "./ConfFormulario.vue?vue&type=script&lang=js"

import "./ConfFormulario.vue?vue&type=style&index=0&id=2aaa8672&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__